import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";

const ConfirmationDialog = ({ title, text, color, open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{text}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onConfirm}
        color={color}
        variant="contained"
      >
        Confirm
      </Button>
      <Button onClick={onClose} color="primary" variant="outlined">
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
